import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
export var STEP;
(function (STEP) {
  STEP["HELP_CENTER_ARTICLE"] = "HELP_CENTER_ARTICLE";
  STEP["CONFIRMATION"] = "CONFIRMATION";
  STEP["LOGGED_OUT_CONTACT_US"] = "LOGGED_OUT_CONTACT_US";
  STEP["LOGGED_OUT_SELECT_TOPIC"] = "LOGGED_OUT_SELECT_TOPIC";
})(STEP || (STEP = {}));
export var EVENT;
(function (EVENT) {
  EVENT["LOGIN_MODAL_PAGE"] = "LOGIN_MODAL_PAGE";
  EVENT["HOW_CAN_WE_HELP_PAGE"] = "HOW_CAN_WE_HELP_PAGE";
  EVENT["DOES_THIS_HELP_PAGE"] = "DOES_THIS_HELP_PAGE";
  EVENT["CONTACT_US_PAGE"] = "CONTACT_US_PAGE";
  EVENT["CONFIRMATION_PAGE"] = "CONFIRMATION_PAGE";
})(EVENT || (EVENT = {}));
export var validateEmail = function validateEmail(email) {
  return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase());
};